// @ts-expect-error Untyped module
import Cookies from 'js-cookie';
import { isQA } from '../constants/apiEnvironments';
import { getQueryParam } from '../routing/getQueryParam';
import UsageTrackerContainer from './UsageTrackingContainer';
import { checkUrlForUUID } from './uuidUtils';
export const QUERY_PARAM_SHOULD_USE_COOKIES_BY_CATEGORY = 'cookies_by_category';
export const checkCookiesHaveBeenAcceptedBeforeSignup = () => {
  const hasCookiesOrEmail = UsageTrackerContainer.areCookiesAccepted || UsageTrackerContainer.isEmailProvided;
  return hasCookiesOrEmail && !checkUrlForUUID();
};
export const hasDeclinedCookies = () => Cookies.get('__hs_cookie_cat_pref') && Cookies.get('__hs_cookie_cat_pref').includes('1:false,') || Cookies.get('__hs_opt_out') === 'yes';
export const shouldShowManageCookies = () => {
  const shouldUseCookiesByCategoryQueryParam = Boolean(getQueryParam(QUERY_PARAM_SHOULD_USE_COOKIES_BY_CATEGORY));
  return isQA && shouldUseCookiesByCategoryQueryParam;
};